export const labels: string[] = ["today", "day", "week", "month", 'year']